// extracted by mini-css-extract-plugin
export var bannerImageDesktop = "style-mod--banner-image-desktop--b4bec";
export var bannerImageMobile = "style-mod--banner-image-mobile--77837";
export var bigBanner = "style-mod--big-banner--22ba5";
export var container = "style-mod--container--8fcc4";
export var content = "style-mod--content--70d38";
export var countdown = "style-mod--countdown--3a6e2";
export var countdownContainer = "style-mod--countdown-container--338bd";
export var messageModal = "style-mod--message-modal--0c663";
export var modalBox = "style-mod--modal-box--c85fb";
export var number = "style-mod--number--48feb";
export var permanentBannerWithCountdown = "style-mod--permanent-banner-with-countdown--396db";
export var smallBanner = "style-mod--small-banner--bbf88";
export var smallContainer = "style-mod--small-container--71890";
export var smallCountdown = "style-mod--small-countdown--8895b";
export var smallNumber = "style-mod--small-number--d280c";
export var smallText = "style-mod--small-text--cb2c2";
export var smallTitle = "style-mod--small-title--0d70a";
export var text = "style-mod--text--a8ef3";
export var timer = "style-mod--timer--9ad84";
export var title = "style-mod--title--cceb1";
export var triangle = "style-mod--triangle--d4471";